<template>
<div class="page leave-requests">
  <h1>Verlofaanvragen</h1>
</div>
</template>

<script>
export default {
name: "LeaveRequests"
}
</script>
